import { useCallback, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import RouteGuard from "./components/RouteGuard";
import { routes } from "./routes/routesConfig";
import socket from "./socket/socket";

function SocketJoin() {
  const userId = useSelector((state) => state.auth.userInfo?._id);
  useEffect(() => {
    if (!userId) return undefined;
    if (!socket.connected) socket.connect();
    const join = () => {
      socket.emit("join", { userId, portal: "admin" });
    };
    join();
    socket.on("connect", join);
    return () => socket.off("connect", join);
  }, [userId]);
  return null;
}

function App() {
  return (
    <Router>
      <SocketJoin />

      <Routes>

        {/* {routes.map((r) => (
          <Route
            key={r.path}
            path={r.path}
            element={<RouteGuard isProtected={r.isProtected} adminOnly={r.adminOnly}>{r.element}</RouteGuard>}
          />
        ))} */}


{routes.map((r) => (
  <Route
    key={r.path}
    path={r.path}
    element={
      r.isProtected ? (
        <RouteGuard isProtected={r.isProtected} adminOnly={r.adminOnly} superAdminOnly={r.superAdminOnly}>
     
          {r.element}
        </RouteGuard>
      ) : (
        r.element
      )
    }
  />
))}


          <Route path="*" element={<Navigate to="/" replace />} />


      </Routes>
    </Router>
  );
}



export default App;
